import { request } from "utils/request";
import { AxiosPromise } from "axios";
import { RevenuePreset } from "types/revenue";

export const revenueApi = {
  summary: (preset: RevenuePreset): AxiosPromise<any> =>
    request({
      url: "/v1/admin/revenue/summary",
      params: { preset },
    }),

  summaryDetail: (params: { preset?: RevenuePreset; month?: number; year?: number }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/revenue/summary/detail",
      params,
    }),

  monthlyChart: (year: number): AxiosPromise<any> =>
    request({
      url: "/v1/admin/revenue/chart/monthly",
      params: { year },
    }),

  topCustomersChart: (year: number): AxiosPromise<any> =>
    request({
      url: "/v1/admin/revenue/chart/top-customers",
      params: { year },
    }),

  topCustomersAllTimeChart: (): AxiosPromise<any> =>
    request({
      url: "/v1/admin/revenue/chart/top-customers-all-time",
    }),
};
